var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSanitization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FFF1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 8.948a1.383 1.383 0 00-.8-1.265A19.929 19.929 0 0016 6a19.929 19.929 0 00-8.199 1.682A1.383 1.383 0 007 8.948v6.874a11.057 11.057 0 007.045 10.32l.96.373c.64.248 1.35.248 1.99 0l.96-.372A11.057 11.057 0 0025 15.822V8.948zm-3.143 4.018l-5.431 7.409a1.126 1.126 0 01-.821.456h-.09c-.299 0-.585-.119-.796-.33L10.6 16.383a1.125 1.125 0 011.591-1.59l3.007 3.008a.225.225 0 00.341-.026l4.5-6.14a1.125 1.125 0 111.815 1.331h.003z",
    fill: "#B5393F"
  }))));
}
export default SvgSanitization;